import {Selectors} from '../Settings';
import Gallery from '../Elements/Gallery';
import GallerySlider from '../Elements/GallerySlider';
import MediaSlider from '../Elements/MediaSlider';

class GalleryController {
  constructor() {
    this.initializeElements();
  }

  initializeElements() {
    let _self = this;

    $(Selectors.gallerySlider).each(function () {
      _self.initializeElement($(this).find('> .owl-carousel'), GallerySlider);
    });

    $(Selectors.gallery).each(function () {
      _self.initializeElement($(this), Gallery);
    });

    $(Selectors.mediaSlider).each(function () {
      _self.initializeElement($(this).find('> .owl-carousel'), MediaSlider);
    });
  }

  initializeElement($element, elementClass) {
    if ($element.length > 0) {
      new elementClass($element);
    }
  }
}

export default GalleryController;
